<template>
    <v-row class="mx-1 my-7">
        <slot name="meta" />

		<v-col v-if="contentData.Title" cols="12">
			<h3 class="q-title text-center">{{ contentData.Title }}</h3>
		</v-col>

		<slot name="Embeds">
			<div class="columns-wrapper align-stretch" :style="itemsStyle">
                <div v-for="(embed, key) in contentData.Embeds" :key="key" class="column-item pa-2">
                    <div v-html="embed.pretext"></div>
                    <div v-html="embed.code"></div>
                    <div v-html="embed.text"></div>
                </div>
			</div>
		</slot>
    </v-row>
</template>

<script>
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: 'ScriptEmbedGroup',
	mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    Embeds: [{}],
                    Title: '',
                    NumColumns: 2,
                }
            }
        }
    },
}
</script>
